import React, { Component } from 'react'
import { 
  GoogleMap, 
  LoadScript, 
  Marker,
  StandaloneSearchBox } from '@react-google-maps/api'
import Settings from "../provider/base/Settings"
class GoogleMapLocation extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {markerPosition:props.initialPosition, center:props.initialPosition}
    this.searchBox
    this.onPlacesChanged=this.onPlacesChanged.bind(this)
    this.onClickMap=this.onClickMap.bind(this)
    this.libraries=["places"]
  }

  onPlacesChanged(){
    // console.log("onPlacesChanged")
    //this.props.onChangeLocation(this.searchBox.getPlaces())
    const place = this.searchBox.getPlaces()[0]
    const latLng = place.geometry.location
    const coords = {lat:latLng.lat(), lng: latLng.lng()}
    // console.log("PLACE",place)
    this.setState({center:coords, markerPosition:coords})
    this.props.onChangeAddress(place.formatted_address)

  }

  onClickMap({latLng}){
    this.setState({markerPosition:{lat:latLng.lat(), lng: latLng.lng()}})
  }

  //Ver los eventos del mapa para mandar las coordenadas y dirección fuera del componente
  render() {
     return (
        <LoadScript
          id="script-loader"
          googleMapsApiKey={Settings.API_KEY}
          libraries={this.libraries}
          // {...other props}
        >
         
          <GoogleMap
            id='example-map'
            mapContainerStyle={{
              height: "400px",
              width: "100%"
            }}        
            zoom={this.props.zoom}
            center={this.state.center}
            onClick={this.onClickMap}
            // {...other props }
          >
            <Marker onLoad={ref=>{this.marker=ref}} 
                    position={this.state.markerPosition} 
                    draggable
                    onPositionChanged={()=>{this.marker&&this.props.onChangeLocation(this.marker.position)}}/>
             <StandaloneSearchBox
              onLoad={ref=>{this.searchBox=ref}}
              onPlacesChanged={
                this.onPlacesChanged
              }>
                <input
                  ref="refInput"
                  type='text'
                  placeholder='Buscar ...'
                  // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
                  style={{
                    boxSizing: `border-box`,
                    border: `1px solid transparent`,
                    width: `240px`,
                    height: `32px`,
                    padding: `0 12px`,
                    borderRadius: `3px`,
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `14px`,
                    outline: `none`,
                    textOverflow: `ellipses`,
                    position: 'absolute',
                    top: '10px',
                    right: '80px',
                  }}
                />
              </StandaloneSearchBox>
          </GoogleMap>
        </LoadScript>
     )
  }
}

GoogleMapLocation.defaultProps = {
  onChangeLocation:(evt)=>{console.log("ON CHANGE LOCATION", evt)},
  onChangeAddress:(address)=>{console.log("ON CHANGE ADDRESS", address)},
  zoom:10,
  initialPosition:{lat:-31.4179457 , lng:-64.1813292}
}

export default GoogleMapLocation


// WEBPACK FOOTER //
// ./src/components/GoogleMapLocation.js